import classes from './SideNav.module.css'
import { NavLink } from 'react-router-dom'

export default function SideNav({data}) {
    return (
        <nav className={classes['side-nav']}>
            <ul>
                {data.map(link =>
                    <li key={link.fieldId}><NavLink to={link.fieldRoute}>{link.fieldName}</NavLink></li>
                )}
            </ul>
        </nav>
    )
}
